export interface KeyValueStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export const SIDEBAR_COLLAPSED_KEY = "sidebarCollapsed";

export function readSidebarCollapsed(storage?: KeyValueStorage): boolean {
  return storage?.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
}

export function persistSidebarCollapsed(storage: KeyValueStorage | undefined, collapsed: boolean): void {
  storage?.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed));
}
